// import mitt from 'mitt'
// const bus = new mitt()
// export default bus
import mitt from 'mitt'
export default new mitt()
